import { render, staticRenderFns } from "./WidgetRankingVendedores.vue?vue&type=template&id=40c535b0&scoped=true"
import script from "./WidgetRankingVendedores.vue?vue&type=script&lang=ts"
export * from "./WidgetRankingVendedores.vue?vue&type=script&lang=ts"
import style0 from "./WidgetRankingVendedores.vue?vue&type=style&index=0&id=40c535b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c535b0",
  null
  
)

export default component.exports